/** @module csi/table/Tooltip */
define([
	"dojo/_base/declare",
	"csi/html",
	"csi/table",
	"csi/view/Tooltip"
], function(declare, html, csiTable, Tooltip) {

	return declare(Tooltip, {
		/**
		 * @override
		 * Check if target is for table header, and if so, then return parameters to display Heading tooltip
		 */
		_getTargetParams: function(target) {
			const view = this.view;
			const th = target.closest("th");
			const spec = th && view.getColumnSpec(th);

			if (spec) {
				const tooltip = spec.getTooltip();
				const overflows = th.classList.contains(csiTable.CSS_HEADER_OVERFLOW);
				const renderColTooltip = spec.heading?.matrix?.onRenderColumnTooltip;

				if (overflows || tooltip || renderColTooltip) {
					const div = html.create("div", {className: "csi-header-tooltip"});

					html.create("div", spec.getHeaderContentParams(), div);

					if (renderColTooltip) {
						const ctx = view.getContext(spec.columnUrl);
						renderColTooltip(ctx, div);
					} else if (tooltip) {
						html.create("div", {multiLineText: tooltip}, div);
					}

					return {
						connectNode: th,
						content: div,
						position: ["below-centered", "above-centered"],
						refNode: th
					};
				}
			}

			return this.inherited(arguments);
		}
	});
});